<template>
    <div style="font-family: 'Courier New', Courier, monospace;">
    <div class="text-center">
        <span v-if="userData.logo!=0"><img :src="getFiles(userData.logo)" height="40"/></span>
        <span v-else><img src="@/assets/images/logo.png" height="40"/></span><br>
        <h4 style="color:black" class="text-uppercase">{{ userData.business }}</h4>
        <span style="color:black;font-size:13px">Location : {{ userData.location }}</span><br>
        <span style="color:black;font-size:13px">Telephone : {{ userData.contact }}</span><br><br>
        <span style="color: black;font-size:13px" class="text-decoration-underline"><b> PAYMENT RECIEPT</b></span><br>
        <span style="color:black;font-size:13px"> Reciept No : {{ this.$route.query.id }}</span><br>
        <span style="color:black;font-size:13px"> Date : {{ receiptDate }}</span>
    </div>
        <table class="table table-sm mt-1" style="color: black;" density="compact">
            <thead><tr><th>Qty</th><th>Item Name</th><th>Price</th></tr></thead>
            <tbody>
            <tr v-for="item in ordersbyid" :key="item.id">
                <td>{{ item.quantity }} {{ item.unit }} </td>
                <td>{{ item.product }}</td>
                <td>{{ commas(item.price) }}</td>
                </tr>
            </tbody>
        </table>
    <div class="mt-2 text-center">
        <span style="color: black;font-size:14px"><b> AMOUNT PAID : {{ commas(receiptAmount) }}</b></span><br>
        <h6 style="color: black;" class="my-4 text-center">Signature : .........................</h6>
        <p style="color:black;font-size:13px">Printed by : {{ userData.username }}
        <br>Thanks for Supporting Us. <br> Printed Via Afrimed Software
        <br> www.afrimedsolutions.com </p>
    </div>
    </div>
</template>

<script>
import appConfig from "@/app.config";
import axios from "axios";
export default {
    page: {
      title: "Print Reciept",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    data() {
        return {
            userData: JSON.parse(localStorage.getItem("user")),
            ordersbyid:[],
            addedon:'',
            amount:'',
            hiddenPrintOverlays: [],
            printCleanupBound: null,
        };
    },
    computed: {
      receiptAmount() {
        if (this.amount !== '' && this.amount !== null && this.amount !== undefined) {
          return Number(this.amount || 0);
        }

        return this.ordersbyid.reduce((total, item) => {
          const unitPrice = Number(item.price || 0);
          const quantity = Number(item.quantity || 0);
          return total + (unitPrice * quantity);
        }, 0);
      },
      receiptDate() {
        return this.addedon || new Date().toLocaleDateString("fr-CA");
      },
    },
    methods: {
        async showticket(){
        this.transaction_id=this.$route.query.id;
        let url = `/orderbyid/${this.transaction_id}`;
        await axios.get(url).then((response) => {
          this.ordersbyid = response.data.orders;
          });
      },
      async showOrder(){
        this.transaction_id=this.$route.query.id;
        let url = `/showorderbyid/${this.transaction_id}`;
        await axios.get(url).then((response) => {
        const order = response.data.order?.[0];
        this.addedon = order?.added_on || '';
        this.amount = order?.amount ?? '';
        });
        },
    
        getFiles(name){
        let url = axios.defaults.baseURL;
        let imagelink = (url).slice(0,-3)+"logos/"+name;
        return imagelink;
        },
      commas(x) { return Number(x || 0).toLocaleString(); },
      prepareForPrint() {
        const selectors = [".toast-container", ".notifications-container"];
        this.hiddenPrintOverlays = [];

        selectors.forEach((selector) => {
          document.querySelectorAll(selector).forEach((element) => {
            this.hiddenPrintOverlays.push({
              element,
              display: element.style.display,
            });
            element.style.display = "none";
          });
        });

        document.body.classList.add("printing-reciept");
      },
      cleanupAfterPrint() {
        this.hiddenPrintOverlays.forEach(({ element, display }) => {
          element.style.display = display;
        });
        this.hiddenPrintOverlays = [];
        document.body.classList.remove("printing-reciept");
      },
    },
    mounted() {
        this.showticket();
        this.showOrder();
        this.printCleanupBound = () => {
          this.cleanupAfterPrint();
          this.$router.go(-1);
        };
        window.addEventListener("afterprint", this.printCleanupBound);
        setTimeout(() => {
          this.prepareForPrint();
          window.print();
        }, 1800);
    },
    beforeDestroy() {
      if (this.printCleanupBound) {
        window.removeEventListener("afterprint", this.printCleanupBound);
      }
      this.cleanupAfterPrint();
    },
}
</script>

<style>
body.printing-reciept .toast-container,
body.printing-reciept .notifications-container {
  display: none !important;
}

@media print {
  .toast-container,
  .notifications-container {
    display: none !important;
  }
}
</style>
